var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotlaLands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "#EA5455",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.354 22.646L28.354 16.646C28.26 16.552 28.133 16.5 28 16.5H22C19.71 16.5 18.5 17.71 18.5 20V32C18.5 34.29 19.71 35.5 22 35.5H31C33.29 35.5 34.5 34.29 34.5 32V23C34.5 22.867 34.447 22.74 34.354 22.646ZM28.5 18.207L32.793 22.5H31C29.271 22.5 28.5 21.729 28.5 20V18.207ZM31 34.5H22C20.271 34.5 19.5 33.729 19.5 32V20C19.5 18.271 20.271 17.5 22 17.5H27.5V20C27.5 22.29 28.71 23.5 31 23.5H33.5V32C33.5 33.729 32.729 34.5 31 34.5ZM30.5 26C30.5 26.276 30.276 26.5 30 26.5H23C22.724 26.5 22.5 26.276 22.5 26C22.5 25.724 22.724 25.5 23 25.5H30C30.276 25.5 30.5 25.724 30.5 26ZM27.5 30C27.5 30.276 27.276 30.5 27 30.5H23C22.724 30.5 22.5 30.276 22.5 30C22.5 29.724 22.724 29.5 23 29.5H27C27.276 29.5 27.5 29.724 27.5 30Z",
    fill: "#EA5455"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotlaLands);
export default __webpack_public_path__ + "static/media/totla-lands.01362374c92b15a9cfbe4007c0c671e8.svg";
export { ForwardRef as ReactComponent };